import { getApiInstance } from '../helpers';

const postWorkdeskAssignTickets = (ticketIds: string[]) => {
  return getApiInstance()
    .post('/ticket/assign', {
      ticketIds,
    })
    .then((res) => {
      console.debug(`/ticket/assign res.data `, res.data);
      if (!res.data)
        throw Error(`/ticket/assign didn't return new tickets data`);
      return res.data;
    });
};
export const assignTicketsService = {
  postWorkdeskAssignTickets,
};
